module.exports = __webpack_public_path__ + "static/11-9d2260a232325edec08e7ef9abdc803a.png";